/** Given names used for random characters; also offered by the house designer. */
export const MALE_NAMES = [
  'Aldric', 'Alaric', 'Aldous', 'Arnulf', 'Baldric', 'Bertram', 'Brand', 'Cedric', 'Conrad', 'Cuthbert',
  'Dunstan', 'Edmund', 'Edric', 'Egbert', 'Eldred', 'Emeric', 'Erwin', 'Falk', 'Fulk', 'Garrick',
  'Gerard', 'Godfrey', 'Gunther', 'Halvard', 'Harold', 'Hartmut', 'Hugh', 'Ingram', 'Jorund', 'Leofric',
  'Lothar', 'Manfred', 'Merek', 'Norbert', 'Osric', 'Osmund', 'Otto', 'Piers', 'Radulf', 'Rainer',
  'Rodric', 'Roland', 'Sigmund', 'Stefan', 'Theobald', 'Tristan', 'Ulric', 'Walter', 'Warin', 'Wulfric',
  'Wystan', 'Hadrian', 'Oswin', 'Beorn', 'Kasimir', 'Lambert', 'Heribert', 'Gawain', 'Randolf', 'Alwin',
];

export const FEMALE_NAMES = [
  'Adela', 'Agatha', 'Aleth', 'Amalia', 'Berta', 'Beatrix', 'Cecily', 'Clara', 'Constance', 'Edith',
  'Eleanor', 'Elfrida', 'Elsbeth', 'Emma', 'Ermengard', 'Freya', 'Gisela', 'Gytha', 'Hedwig', 'Helga',
  'Hilda', 'Idonea', 'Ingrid', 'Isolde', 'Joan', 'Katrin', 'Leofwen', 'Linnea', 'Margery', 'Mathilda',
  'Maud', 'Nesta', 'Odila', 'Petronilla', 'Rhosyn', 'Rowena', 'Sibyl', 'Sunniva', 'Thea', 'Ulrika',
  'Venetia', 'Walburga', 'Wilhelmina', 'Winifred', 'Yolande', 'Alys', 'Brunhild', 'Eadgyth', 'Hawise', 'Ysolde',
  'Gerda', 'Lioba', 'Mechthild', 'Oda', 'Richenza', 'Sigrid', 'Tove', 'Hrodna', 'Aelfgifu', 'Judith',
];
